import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import getUserAdvancedStore from "../../../../../stores/user-store/advanced-store";
import LoadMoreComments from "./loadMoreComments";
import Et3Table from "../../../../../core/et3-table";
import React from "react";
import { USER_ADMIN_COMMENTS_HEADERS } from "../../../../../constants/table-custom-headers/User";

const UserCommentsTable = withLiteObserverAndTheme(() => {
  const commentsArray = getUserAdvancedStore().getNewAddedComment.get();
  const commentExist = getUserAdvancedStore().ifCommentsExist.get();

  return commentExist ? (
    <React.Fragment>
      <Et3Table
        columns={USER_ADMIN_COMMENTS_HEADERS}
        rows={commentsArray}
        title={""}
        shouldBeFlagged={false}
        titleKey={"COMMENTS"}
      />
      <LoadMoreComments />
    </React.Fragment>
  ) : null;
});
export default UserCommentsTable;
